export const serverLogsDownloadStatus = {
    FINISHED: 'Finished',
    ZIP_READY: "zipready",
    IN_PROGRESS: "in_progress",
    ERROR: "error",
    BUSY: "busy"
};